export const ViewState = {
    IDLE: "idle",
    BUSY: "busy",
    ERROR: "error",
    READY: "ready"
}

export const SET_SUMMARY_PAYLOAD = "SET_SUMMARY_PAYLOAD"

export const TOGGLE_HEADER_FIXED = "TOGGLE_HEADER_FIXED";
export const SET_HEADER_COORDINATES = "SET_HEADER_COORDINATES";
export const SET_SEARCH_SENTENCE = "SET_SEARCH_SENTENCE";
export const UPDATE_VIEWPORT_WIDTH = "UPDATE_VIEWPORT_WIDTH";

export const RELOAD_TABLE = "RELOAD_TABLE";

export const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';
export const RESET_QUERY_PARAMS = 'RESET_QUERY_PARAMS';

export const SET_TABLE_MISCS = 'SET_TABLE_MISCS';
export const SET_TABLE_MISCS_STATUS = 'SET_TABLE_MISCS_STATUS'

export const SET_SEARCHER_HEADER = 'SET_SEARCHER_HEADER'